import Error404 from "../Error404";
import Error403 from "../Error403";
import constants from "../constants";
import { getDataFromStorage } from "../util";
import { Outlet, useLocation } from "react-router-dom";

const blockedCorporatePaths = ["/jobs", "/hackthons", "/university-dashboard"];
const blockedCorporateRoutePatterns = [
  /^\/batches\/\d+\/settings\/skillmap$/,
  /^\/batches\/\d+\/timeline$/,
];
const blockedCorporateDashboardQueries = [
  "scope-ar=leaderboard",
  "scope-ar=percentile",
  "scope-ar=time-spent",
  "scope-ar=mock-test",
  "scope-ar=coding-challenges",
  "scope-ar=ai-interviews",
  // "scope-ar=attendance",
];

const isBlockedCorporatePath = (pathname, search) => {
  const path = pathname.toLowerCase();
  const query = search.toLowerCase();

  if (blockedCorporatePaths.includes(path)) {
    return true;
  }

  if (blockedCorporateRoutePatterns.some((pattern) => pattern.test(path))) {
    return true;
  }

  if (path.includes("/dashboard")) {
    return blockedCorporateDashboardQueries.some((item) =>
      query.includes(item)
    );
  }

  return false;
};

const RequireAuth = ({ allowedRoles, children, isRouteFound = true }) => {
  const role = getDataFromStorage("role") || "/dp";
  const location = useLocation();
  const isAllowed = allowedRoles.some((alRole) =>
    alRole.includes(role)
  );

  const isCorporateAccount =
    Number(localStorage.getItem("university_type")) ===
    constants.ACCOUNT_TYPE.CORPORATE;

  if (!isAllowed) {
    return <Error404 />;
  }

  // if(!isRouteFound) {
  //   return <Error404 />;
  // }

  if(
    isCorporateAccount && 
    isBlockedCorporatePath(location.pathname, location.search)
  ) {
    return <Error403 />;
  }

  return children ? children : <Outlet />;
};

export default RequireAuth;
